import HttpRequest from './http-request';
import { AxiosResponse } from "axios";

interface CreateUserInput {
  name: string;
  email: string;
  password: string;
}

interface StepsData {
  id: string;
  name: string;
  email: string;
}

interface CoverData {
  success: boolean;
  message: string;
  data: {
    cover: string;
  };
}

 interface CreateCover {
  cover: File;
}


const releaseService = () => {
  const { post, get } = HttpRequest();


  const getReleasesData = (data: string): Promise<AxiosResponse<any>> => {
    return get(data);
  };

  const sendReleases = (input: CreateUserInput): Promise<AxiosResponse<StepsData>> => {
    return post<StepsData>('step-data', input);
  };

  const sendCover = (input: any,id:any): Promise<AxiosResponse<CoverData>> => {
    return post<CoverData>(`releases/${id}`, input);
  };

  return {
    getReleasesData,
    sendReleases,
    sendCover
  };
};

export default releaseService;
